import React, { useRef, useState, useEffect } from "react";

import 'zingchart/es6';
import ZingChart from 'zingchart-react';
import "./gauge.css";

export const Sunburst = (props) => {
  const zingChart = useRef(null);

  //general settings such as number of questions
  //  var groupedCategories = _.groupBy(chartData.questionResults, function(typeOfQues) {
  //   return typeOfQues.type;
  // });
  var groupedCategories = props.data.questionResults;

  //init rules
  var rulesForMainColourIndices = [];
  var rulesForMainColourQuestions = [];
  var rulesForSecondaryColour = [];
  var rulesAccummulatedValues = 0;
  var rulesAccummulatedValuesIndices = 0;

  var itemCount = 0;

  //init labels
  var labelsForSectionquestions = [''];
  var labelsForPercentages = [''];
  var labelsSPACES = 0;
  //init hovering
  var markersSet = [];

  //creating 2 labels (category names and ratings), markers and 3 rules dynamically
  for (var i = 0; i < groupedCategories.length; i++) {
    //going through every category
    var nameOfCategory = Object.keys(groupedCategories[i])[0];
    var allSubCategories = Object.values(groupedCategories[i])[0];

    var numberOfItemsInCategory = 0;
    var scoreAveragesSummed = 0
    for (var j = 0; j < allSubCategories.length; j++) {
      //going through every sub category
      var subCategoryArray = Object.values(allSubCategories[j])[0];

      var numberOfItemsInSubCategory = subCategoryArray.length;
      //adding up number of items in category
      numberOfItemsInCategory += numberOfItemsInSubCategory;

      //adding up score averages in all subcategories of category

      var subCategoryAverageSum = subCategoryArray.map(obj => (Math.trunc(obj.score * 100 / obj.maximumScore) / 10)).reduce((acc, obj) => obj + acc);
      scoreAveragesSummed += subCategoryAverageSum

      var mainColour = props.data.questionStyles[nameOfCategory].themeBackground;
      var secondaryColour = props.data.questionStyles[nameOfCategory].subThemeBackground;

      //RULES
      var inferiorLimit = rulesAccummulatedValues;
      var upperLimit = rulesAccummulatedValues + numberOfItemsInSubCategory * 4;
      var inferiorLimitForIndices = rulesAccummulatedValuesIndices;
      var upperLimitForIndices = rulesAccummulatedValuesIndices + numberOfItemsInSubCategory * 2;

      //rules 1 - main colour for indices of questions
      rulesForMainColourIndices.push({
        rule: '%v <= ' + upperLimitForIndices.toString() + ' && %v > ' + inferiorLimitForIndices.toString(),
        backgroundColor: mainColour,
        alpha: 1
      });

      //rules 2 - main colour for primary colour of questions
      rulesForMainColourQuestions.push({
        rule: '%v <= ' + upperLimit.toString() + ' && %v > ' + inferiorLimit.toString(),
        backgroundColor: mainColour,
        alpha: 1
      });

      //rules 3 - secondary colour of questions
      rulesForSecondaryColour.push({
        rule: '%v <= ' + upperLimit.toString() + ' && %v > ' + inferiorLimit.toString(),
        backgroundColor: secondaryColour,
        alpha: 1
      });

      rulesAccummulatedValues += numberOfItemsInSubCategory * 4;
      rulesAccummulatedValuesIndices += numberOfItemsInSubCategory * 2;

      //MARKERS
      for (var l = 0; l < subCategoryArray.length; l++) {
        var rawScore = subCategoryArray[l].score;
        var maxScore = subCategoryArray[l].maximumScore;
        var scoreOfMetric = (rawScore * 10 / maxScore).toFixed(2);
        var scoreOfMetricTrunced = Math.trunc(scoreOfMetric);
        var indexOfMetric = subCategoryArray[l].index;

        var offSetStart = 0.1;
        var offSetEnd;
        for (var k = 0; k < scoreOfMetricTrunced; k++) {
          offSetEnd = 1 - (offSetStart + 0.075);
          markersSet.push({
            type: "area",
            range: [(indexOfMetric * 2) - 1, (indexOfMetric * 2) + 0.9],
            offsetStart: offSetStart,
            offsetEnd: offSetEnd,
            backgroundColor: mainColour,
            alpha: 1
          });
          offSetStart += 0.006 + 0.075;
        }
        if (scoreOfMetric > scoreOfMetricTrunced.toFixed(2)) { //we have a score such as 1.3 out of 2
          var differenceBetweenScores = scoreOfMetric - scoreOfMetricTrunced.toFixed(2);
          offSetEnd = 1 - (offSetStart + 0.075) + (0.075 - differenceBetweenScores * 0.075);
          markersSet.push({
            type: "area",
            range: [(indexOfMetric * 2) - 1, (indexOfMetric * 2) + 0.9],
            offsetStart: offSetStart,
            offsetEnd: offSetEnd,
            backgroundColor: mainColour,
            alpha: 1
          });
        }
      }

    }

    //LABELS
    //label 1 - category names i.e. Environment
    itemCount += numberOfItemsInCategory; //adding up number of items in categories
    var nameOfCategoryCharacters = nameOfCategory.split("");

    var slotForLabel = numberOfItemsInCategory * 4 - 2; //i.e. we have 10 spaces and "Outstanding" has 11 letters
    if (slotForLabel < 0) slotForLabel = 0;
    if (nameOfCategoryCharacters.length > slotForLabel) {
      while (nameOfCategoryCharacters.length > slotForLabel) {
        nameOfCategoryCharacters.pop();
      }
      nameOfCategoryCharacters[nameOfCategoryCharacters.length - 1] = '.';
      nameOfCategoryCharacters[nameOfCategoryCharacters.length - 2] = '.';
    }

    labelsSPACES = numberOfItemsInCategory * 4 - nameOfCategoryCharacters.length;
    var sizeToFillIn = Math.floor(labelsSPACES / 2);
    if (sizeToFillIn < 0) { //case when there is only one item in the category
      sizeToFillIn = 0;
    }
    labelsForSectionquestions = labelsForSectionquestions.concat(Array(sizeToFillIn).fill(""));
    labelsForSectionquestions = labelsForSectionquestions.concat(nameOfCategoryCharacters);
    if ((sizeToFillIn * 2 != labelsSPACES) && sizeToFillIn != 0) sizeToFillIn++;
    labelsForSectionquestions = labelsForSectionquestions.concat(Array(sizeToFillIn).fill(""));

    //label 2 - ratings i.e. Satisfactory (70%)
    var percentageNumberForCategory = Math.trunc((scoreAveragesSummed / numberOfItemsInCategory) * 10);
    //now that it's calculated, retrieve label i.e. good/outstanding
    var percentageLabelForCategory = "";
    for (var eachLabel in props.data.sections) {
      if (percentageNumberForCategory >= props.data.sections[eachLabel].lowerLimit && percentageNumberForCategory < props.data.sections[eachLabel].upperLimit) {
        percentageLabelForCategory = eachLabel.toUpperCase();
        break;
      }
    }

    var questionOfPercentageCharacters = percentageLabelForCategory.split("");

    var slotForLabelWithoutPercentages = numberOfItemsInCategory * 4 - 8; //i.e. we have 10 spaces and "Outstanding" has 11 letters; 2 spaces for limits (left right) and 6 more for percentages (compulsory) i.e. _(50%)
    if (numberOfItemsInCategory * 4 - 8 < 0) slotForLabelWithoutPercentages = 0;
    if (questionOfPercentageCharacters.length > slotForLabelWithoutPercentages) {

      while (questionOfPercentageCharacters.length > slotForLabelWithoutPercentages) {
        questionOfPercentageCharacters.pop();
      }
      questionOfPercentageCharacters[questionOfPercentageCharacters.length - 1] = '.';
      questionOfPercentageCharacters[questionOfPercentageCharacters.length - 2] = '.';
    }

    labelsSPACES = numberOfItemsInCategory * 4 - questionOfPercentageCharacters.length;
    var percentageText = " (" + percentageNumberForCategory.toString() + "%)";
    var sizeToFillIn = Math.floor((labelsSPACES - 6) / 2);
    if (sizeToFillIn < 0) { //case when there is only one item in the category
      sizeToFillIn = 0;
      percentageText = percentageNumberForCategory.toString() + "% ";
    }
    labelsForPercentages = labelsForPercentages.concat(Array(sizeToFillIn).fill(""));
    labelsForPercentages = labelsForPercentages.concat(questionOfPercentageCharacters);
    labelsForPercentages = labelsForPercentages.concat(percentageText.split(""));
    if ((sizeToFillIn * 2 != labelsSPACES - 6) && sizeToFillIn != 0) sizeToFillIn++;
    labelsForPercentages = labelsForPercentages.concat(Array(sizeToFillIn).fill(""));

    for (var j = 0; j < allSubCategories.length; j++) {
      //addding the computed label i.e. outstanding to the object containing the data
      subCategoryArray = Object.values(allSubCategories[j])[0];
      for (var t = 0; t < subCategoryArray.length; t++) {
        var objectOfResponse = subCategoryArray[t];
        retrieveObjectOnIndex(objectOfResponse.index.toString()).label = percentageLabelForCategory + percentageText;
      }
    }
  }
  labelsForSectionquestions.push('');
  labelsForSectionquestions.push('');
  labelsForPercentages.push('');

  //LABELS 3 (indices) + HOVERING
  var labelsForQuestions = [''];
  var seriesHovering = [];
  for (var j = 1; j <= itemCount; j++) {
    labelsForQuestions.push(j.toString());
    labelsForQuestions.push(' ');
    seriesHovering.push({
      values: [j * 2], //next value, because there is 1,"",2,"" etc
      backgroundColor: 'gray',
      size: "100%",
      indicator: [0, 10, 0, 0, 5.3],
      text: "<u>Question number " + j.toString() + ' </u>: ' + retrieveObjectOnIndex(j.toString()).question + '<br><u>Score</u>: ' + retrieveObjectOnIndex(j.toString()).score.toString() + '/' + retrieveObjectOnIndex(j.toString()).maximumScore.toString() + ' (' + ((retrieveObjectOnIndex(j.toString()).score * 10 / retrieveObjectOnIndex(j.toString()).maximumScore) * 10).toFixed(2).toString() + '%)' + '<br><u>Section is</u>: ' + retrieveObjectOnIndex(j.toString()).type + '<br><u>SubSection is</u>: ' + retrieveObjectOnIndex(j.toString()).subType + '<br><u>Score for Section is</u>: ' + retrieveObjectOnIndex(j.toString()).label,
      alpha: 0
    });
  }


  function retrieveObjectOnIndex(value) {

    for (var m = 0; m < props.data.questionResults.length; m++) {
      var eachCategoryName = Object.keys(props.data.questionResults[m])[0];
      var subCategories = Object.values(props.data.questionResults[m])[0];

      for (var n = 0; n < subCategories.length; n++) {
        var eachSubCategoryName = Object.keys(subCategories[n])[0];
        var items = Object.values(subCategories[n])[0];
        for (var o = 0; o < items.length; o++) {
          var eachItem = items[o];
          if (eachItem.index.toString() === value) {
            eachItem.type = eachCategoryName;
            eachItem.subType = eachSubCategoryName;
            return eachItem;
          }
        }

      }
    }
    return null;
  }

  var myConfig = {
    theme: "classic",
    type: "gauge",
    globals: {
      fontSize: 25
    },
    plotarea: {
      marginTop: 0
    },
    scaleR: { //the inner scale
      aperture: 360,
      minValue: 1,
      maxValue: (itemCount * 2 + 1),
      maxTicks: (itemCount * 2 + 1),
      step: 1,
      center: {
        visible: true,
        size: 18,
        backgroundColor: "white",
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      tick: {
        visible: false,
      },
      labels: labelsForQuestions,
      item: {
        fontSize: 9,
        fontWeight: "normal",
        fontColor: "white",
        angle: 0,
        offsetR: -18
      },
      maxItems: (itemCount * 2 + 1),
      ring: {
        size: 13,
        rules: rulesForMainColourIndices,
      },
      markers: markersSet,
      guide: {
        alpha: 1
      },
      plot: {
        csize: "5%",
        size: "100%",
        backgroundColor: "#000000"
      },
    },
    tooltip: {
      borderRadius: 5,
      backgroundColor: "white",
      fontColor: "black",
      fontSize: 10,
      padding: "5 10",
      borderColor: "gray",
      borderWidth: 1,
      text: "%t"
    },
    series: seriesHovering,
    scaleR2: {
      aperture: 360,
      minValue: 1,
      maxValue: (itemCount * 4 + 1),
      maxTicks: (itemCount * 4 + 1),
      step: 1,
      center: {
        visible: false,
      },
      tick: {
        visible: false,
      },
      item: {
        offsetR: -31,
        fontSize: 15,
        fontFamily: "Inconsolata",
        fontColor: "white",
        angle: "auto",
      },
      maxItems: (itemCount * 4 + 1),
      labels: labelsForSectionquestions,
      ring: {
        size: 30,
        rules: rulesForMainColourQuestions,
      },
      guide: {
        alpha: 0
      }
    },
    scaleR3: { //last scale
      aperture: 360,
      minValue: 1,
      maxValue: (itemCount * 4 + 1),
      maxTicks: (itemCount * 4 + 1),
      step: 1,
      center: {
        visible: false,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      tick: {
        visible: false,
      },
      item: {
        offsetR: -30,
        fontSize: 15,
        fontFamily: "Inconsolata",
        fontWeight: "bold",
        fontColor: "white",
        angle: "auto",
      },
      maxItems: (itemCount * 4 + 1),
      labels: labelsForPercentages,
      ring: {
        size: 30,

        rules: rulesForSecondaryColour,
      },
      guide: {
        alpha: 0
      }
    },
    scale: {
      sizeFactor: 0.74
    },
    scale2: {
      sizeFactor: 0.865
    },
    scale3: {
      sizeFactor: 1.0
    }
  };
  useEffect(()=>{
    if(props.imageReturn && zingChart){
      if(zingChart.current){
        props.setDiagramImage(zingChart.current.getimagedata());
      }
    }

  },[])
  useEffect(()=>{
    if(props.imageReturn && zingChart){
      if(zingChart.current){
        props.setDiagramImage(zingChart.current.getimagedata());
      }
    }

  },[zingChart])
  return (
    <div style={{
      overflow: "hidden",
      borderRadius: "100%",
      height: 475,
      width: 475,
      textAlign: "center",
      margin: "auto",
    }}>
        <ZingChart output="canvas" ref={zingChart} data={myConfig} />
    </div>
  );
};